module.exports = __webpack_public_path__ + "img/riskMonitorBgc.d8859289.jpg";